<div class="selected-sections-toolbar" [class.visible]="internalVisible">
  <div class="toolbar-content">
    <!-- Header Section -->
    <div class="toolbar-header">
      <mat-checkbox
        class="selection-checkbox"
        [checked]="true"
        (click)="onClearSelection()"
        matTooltip="Click to clear selection"
        matTooltipPosition="below"
      ></mat-checkbox>
      <div class="selection-info">
        <span class="selection-title">{{ getSelectedSectionsText() }}</span>
        <!-- Selected sections as chips -->
        <div class="selected-sections-chips">
          <mat-chip-set>
            @for (section of selectedSections; track section) {
              <mat-chip (removed)="onRemoveSection(section)" removable>
                {{ getSectionSlug(section) }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            }
          </mat-chip-set>
        </div>
      </div>
    </div>

    <!-- Actions Section -->
    <div class="toolbar-actions">
      <mat-checkbox
        class="force-recompute-checkbox"
        [(ngModel)]="forceRecompute"
        matTooltip="Regenerate even if a report already exists"
        matTooltipPosition="below"
      >
        Force recompute
      </mat-checkbox>

      <!-- Cancel Button -->
      <button
        mat-button
        class="cancel-button"
        (click)="onCancel()"
        matTooltip="Cancel and clear selection"
        matTooltipPosition="below"
      >
        Cancel
      </button>

      <!-- Generate Compliance Reports Button -->
      <button
        mat-raised-button
        color="primary"
        class="generate-reports-button"
        (click)="onGenerateComplianceReports()"
        matTooltip="Generate detailed compliance reports for selected sections"
        matTooltipPosition="below"
      >
        <mat-icon>assessment</mat-icon>
        <span>Generate Compliance Reports</span>
      </button>
    </div>
  </div>
</div>
